import { CSS } from '@grupoboticario/flora-react'

export const sectionBoxCss: CSS = {
  marginBottom: '$6'
}

export const sectionTitleCss: CSS = {
  marginBottom: '$4'
}

export const locationGridCss: CSS = {
  gridTemplateColumns: '1fr',
  gap: '$4',
  '@desktop': { gridTemplateColumns: '2fr 1fr 1fr' }
}

export const remoteToggleRowCss: CSS = {
  marginTop: '$4'
}
